module.exports = __webpack_public_path__ + "img/kia_carnivan.7c0616d5.jpg";